import AppTable from '@launchpad/components/crud/AppTable';
import React from 'react';
import { Link } from 'react-router-dom';
import { AppBadge, AppIcon } from '@launchpad';
import { currency } from '@launchpad/util/NumberHelper';
import StipLogModel from '../models/StipLogModel';
import { getBadgeTypeForStipLogStatus } from '../utils/stipLogs.utils';

export const StipLogsTable = (props: {}) => {
  return (
    <div className="stip-logs-table-holder">
      <AppTable
        parseUrl={false}
        icon="list"
        title="STIP Logs"
        filter={[
          {
            name: 'term',
            type: 'term',
          },
        ]}
        order={[
          {
            field: 'id',
            direction: 'desc',
          },
        ]}
        model={StipLogModel}
        renderCell={(column, item, index) => {
          switch (column.name) {
            case 'amount':
              return currency(item.amount, item.currency);
            case 'status':
              return (
                <AppBadge
                  text={item.status}
                  type={getBadgeTypeForStipLogStatus(item.status)}
                />
              );
            case 'approved':
            case 'approvedByTemenos':
            case 'approvedByPannovate':
              return (
                <AppIcon
                  name={item[column.name] ? 'fa.check' : 'fa.times'}
                  style={{
                    fontSize: 20,
                    color: item[column.name] ? '#4caf50' : '#b74343',
                  }}
                />
              );
            default:
              return undefined;
          }
        }}
        getColumnActions={(file, index) => {
          return (
            <div>
              <Link
                to={`/stip-logs/details/${file.id}`}
                className="button-info"
              >
                Details
              </Link>
            </div>
          );
        }}
      />
    </div>
  );
};

export default StipLogsTable;
